import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PrizeEntity } from '../../domain/entities/PrizeEntity'
import type { PrizeAdminDto } from '@/backend/market/models/PrizeAdminDto'
import type { CouponEntity } from '@/features/coupons/domain/entities/CouponEntity'

export class PrizeModel extends PrizeEntity {
  constructor(dataDto: PrizeAdminDto & { coupon?: CouponEntity }) {
    super()
    mapEntityProperties<PrizeEntity>(this, dataDto, {
      map: {
        coupon: dataDto.coupon
          ? {
              id: dataDto.coupon.id,
              name: dataDto.coupon.translations?.[0]?.name,
              redeemCode: dataDto.coupon.redeemCode
            }
          : undefined
      }
    })
  }
}
